declare const plausible: any

const trackEvent = (action: string, label?: string) => {
  if (process.env.NEXT_PUBLIC_VERCEL_ENV == 'production') {
    try {
      plausible(action, { props: { Label: label } })
    } catch {
      console.log('[plausible] Tracking is disabled')
    }
  } else {
    console.log('[plausible] Track Event', { action, label })
  }
}

const plau = {
  trackEvent
}

export default plau
